import { ComponentPropsWithoutRef, FC } from 'react';

type LastIconProps = ComponentPropsWithoutRef<'svg'>;

export const LastIcon: FC<LastIconProps> = ({ color, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M5.05048 11.6001L4.32693 10.8934L7.23079 7.98958L4.32693 5.08573L5.05048 4.37902L8.66104 7.98958L5.05048 11.6001ZM11.7084 11.6907V4.29248H12.7075V11.6907H11.7084Z"
                fill={color || 'currentColor'}
            />
        </svg>
    );
};
